<template>
  <div class="play-music-container">
    <!-- checkboxes and radiobuttons use checked property and change event -->
    <input
      id="play-music-input"
      type="checkbox"
      checked
      @change="emitChange"
    >
    <span class="play-music-text">
      <div>
        Play background music and sound effects
      </div>
      <div :style="{ fontSize: '0.8em' }">
        (Make sure you're using headphones!)
      </div>
    </span>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PlayMusicCheckbox',
  props: {
    value: Boolean
  },
  methods: {
    emitChange: function(event) {
      // console.log(event.target.checked);
      this.$emit('change', event.target.checked);
    }
  }
})
</script>

<style scoped lang="scss">
.play-music-container {
  display: flex;
  justify-content: center;
}

#play-music-input {
  transform: scale(1.5);
}

.play-music-text {
  padding: 0 0.8em;
  margin: auto 0;
  text-align: center;
}
</style>